import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/documentTypes',
  	  method: 'get',
        params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/documentTypes/inventory',
      method: 'get',
      params
    })
  }
  
export function show(id) {
    return request({
      url: `/documentTypes/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/documentTypes',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/documentTypes/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/documentTypes/${id}`,
      method: 'delete',
    })
  }

  export function chart(params) {
    return request({
        url: '/documentTypes/documentTypes/chart',
        method: 'get',
        params
    })
  }